import React from 'react';

const DeleteTrack = ({ name }) => {
    return (
        <div>
            <p>Please confirm if you wish to delete this <span style={{color: "red"}}>track({name})</span>.</p>
        </div>
    )
}
export default DeleteTrack;